export const enum QueryModule {
   Subscriptions = "SubscriptionsQueries",
   ContinuousLearningSync = "ContinuousLearningSyncQueries",
   AppSettings = "AppSettingsQueries",
   Profile = "ProfileQueries",
   Sse = "SseQueries",
   Watchlist = "WatchlistQueries",
   LiveShows = "LiveShowsQueries",
   GuestProfile = "GuestProfileQueries",
   Plaid = "PlaidQueries",
   Portfolio = "PortfolioQueries",
   CeoVsEmployee = "CeoVsEmployeeQueries",
   Loyalty = "LoyaltyQueries",
   Projects = "ProjectsQueries",
   Healthcheck = "HealthcheckQueries",
   Onboarding = "OnboardingQueries",
   Wallet = "WalletQueries",
   Notifications = "NotificationsQueries",
   WorthData = "WorthDataQueries",
   User = "UserQueries",
   Endorsements = "EndorsementsQueries",
   PortfolioVip = "PortfolioVipQueries",
   PublicProfile = "PublicProfileQueries",
   ProfileAnalytics = "ProfileAnalyticsQueries",
   PublicProjects = "PublicProjectsQueries",
   Startups = "StartupsQueries",
   BugReport = "BugReportQueries",
   ProfileDemo = "ProfileDemoQueries",
}